<template>
  <div>
    <v-layout>
      <div class="flex md6">
        <v-select :items="kurList" :rules="rules" item-text="text" item-value="text" v-model="model.paraBirimi"
          :label="$t('Currency-Unit')" hide-details @change="getKur()"></v-select>
      </div>
      <div class="flex md6">
        <dovizinput v-model="model.kur" :rules="rules" :etiket="$t('Exchange-Amount')"> </dovizinput>
      </div>
    </v-layout>
  </div>
</template>

<script>
  import tool from "../tools";
  import dovizinput from '@/components/app/customcomp/dovizinput.vue'

  var store = {
    debug: true,
    okunuyor: false,
    state: {
      paraBirimleri: []
    },
    setParaBirimleri(newValue) {

      this.state.paraBirimleri = newValue;
    }
  };

  export default {
    components: {
      dovizinput
    },
    props: ["value", "kurtarihi", "rules"],

    computed: {
      model: {
        get: function () {
          this.parabirimiCek();
          //this.gunlukKurlariCek();
          return this.value;
        },
        set: function (newValue) {
          this.$emit("input", newValue);
        }
      }
    },
    data() {
      return {
        items: [],
        defitems: [{
            text: "TL",
          },
          {
            text: "USD",
          },
          {
            text: "AUD",
          },
          {
            text: "DKK",
          },
          {
            text: "EUR",
          },
          {
            text: "GBP",
          },
          {
            text: "CHF",
          },
          {
            text: "SEK",
                          },
          {
            text: "CAD",
          },
          {
            text: "KWD",
          },
          {
            text: "NOK",
          },
          {
            text: "SAR",
          },
          {
            text: "JPY",
          },
          {
            text: "BGN",
          },
          {
            text: "RON",
          },
          {
            text: "RUB",
          },
          {
            text: "IRR",
          },
          {
            text: "CNY",
          },
          {
            text: "PKR",
          },
          {
            text: "QAR",
          },
          {
            text: "MXN",
          },
            {
            text: "AED",
          }
        ],
        kurList: [],
        paraBirimi: null,
        kur: 1,
        fkurtarihi: null,
      };
    },

    created: function () {},


    methods: {

      parabirimiCek() {

        tool.http_post(this, "ParaBirimleri", {
            paraBirimi: "",
            kur: "",
            kurTarihi: ""
          })
          .then(
            response => {
              if (response.body.length != 0) {
                this.kurList = this.defitems;
              } else {
                this.kurList = response.body;
              }
              this.gunlukKurlariCek();
            },
            response => {
              this.kurList = this.defitems;

            }
          );
      },

      gunlukKurlariCek() {
        var tarih = this.kurtarihi

        if (this.kurtarihi == null) {
          tarih = tool.Now_yyyy_MM_dd();
        } else {}

        tool.http_post(this, "KurAra", {
          tarih: tarih
        }).then(
          response => {
            this.items = response.body;
            this.getKur();
          },
          response => {

          }
        );


      },
      kurChange: kurChange,
      paraAra: paraAra,
      paraAraTL: paraAraTL,
      getKur: getKur,
    }
  };


  function paraAra(paraBirimi) {
    return paraBirimi.paraBirimi == this.paraBirimi;
  }

  function paraAraTL(paraBirimi) {
    return paraBirimi.paraBirimi == "TL";
  }

  function kurChange() {
    this.model.kur = this.kur;
  }

  function getKur() {

    var kayitvarmi = this.items.map(function (e) {
      return e.paraBirimi;
    }).indexOf(this.model.paraBirimi);


    if (kayitvarmi != -1) {
      this.model.kur = this.items[kayitvarmi].kur
    } else {
      if (this.model.paraBirimi != 'TL' && this.model.paraBirimi != 'YTL') {
        this.model.kur = 0
      } else {
        this.model.kur = 1
      }
    }

  }
</script>